import { render, staticRenderFns } from "./qs3-08.vue?vue&type=template&id=6b788ef9&scoped=true&"
import script from "./qs3-08.vue?vue&type=script&lang=js&"
export * from "./qs3-08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b788ef9",
  null
  
)

export default component.exports